import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function NightlifeIcon({ size = 20, color = "white", className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8.75 11.875L2.5 5H15L8.75 11.875Z" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.625 18.125H11.875" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.75 18.125V11.875" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 7.5H10" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.25 5C11.25 3.27438 12.6494 1.875 14.375 1.875C16.1006 1.875 17.5 3.27438 17.5 5C17.5 6.72562 16.1006 8.125 14.375 8.125" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
